/* eslint-disable */
<template>
    <div class="ma-0 pa-0">
        <BasicCard :show_title="false">
            <div>
                <v-container>
                    <div v-if="advanced_search">
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center">
                            <span class="text-h6">Ricerca avanzata</span>
                            <span><v-btn fab small text @click.stop="cancelSearch()"><v-icon>close</v-icon></v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="4" v-if="!lock_client" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="cliente"
                                v-model="filter.client_id"
                                :items="clients"
                                item-value="_id"
                                item-text="value.name"
                                clearable
                                @change="updateClient"
                            ></v-autocomplete>
                        </v-col>
                        
                        <v-col cols="4" v-if="locations.length > 1 || (!lock_client && filter.client_id)" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="sede"
                                v-model="filter.location_id"
                                :items="locations"
                                item-value="_id"
                                item-text="value.name"
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                    label="famiglia"
                                    multiple
                                    v-model="filter.search_family"
                                    :items="Object.values(families).filter(f => { return f.enabled})"
                                    item-text="label"
                                    item-value="id"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-divider v-if="(lock_client && locations.length > 1) || !lock_client" class="my-2" />
                    <v-row no-gutters>
                        
                        <v-col cols="4" v-if="!filter_status || filter_status.length == 0" class="d-flex justify-start align-content-center pr-2">
                            <v-autocomplete dense outlined
                                label="stato report"
                                v-model="filter.status"
                                :items="status"
                                item-value="id"
                                item-text="name"
                                multiple
                                clearable
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-start align-content-center pr-2">
                            <v-text-field dense outlined
                                label="codice report"
                                v-model="filter.report_code"
                                clearable
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-start align-content-center">
                            <v-autocomplete dense outlined
                                    label="operatore"
                                    v-model="filter.operator"
                                    :items="filtered_users"
                                    item-value="_id"
                                    item-text="name"
                                    clearable
                                ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <div class="font-weight-bold">Data report</div>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-column">
                            <div class="d-flex justify-left full-width my-2">
                                <v-btn class="" @click="periodChange(0, 0)">oggi</v-btn>
                                <v-btn class="ml-2" @click="periodChange(1, 1)">ieri</v-btn>
                                <v-btn class="ml-2" @click="periodChange(6, 0)">ultimi 7 giorni</v-btn>
                                <v-btn class="ml-2" @click="periodChange(29, 0)">ultimi 30 giorni</v-btn>
                            </div>
                            <div class="d-flex mt-1">
                                <span><CalendarField
                                    v-model="filter.from"
                                    label="da"
                                    clearable>
                                </CalendarField></span>
                                <span class="pl-2"><CalendarField
                                    v-model="filter.to"
                                    :minDate="filter.from"
                                    label="a"
                                    clearable>
                                </CalendarField></span>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex justify-center align-content-center">
                            <v-btn color="primary" class="text-center" @click="search"><v-icon class="pr-2">search</v-icon>Cerca</v-btn>
                            <v-btn color="action" class="text-center ml-2" @click="cancelSearch(false)">annulla</v-btn>
                        </v-col>
                    </v-row>
                    <v-divider class="mt-4"/>
                    </div>
                    <v-row no-gutters>
                        <v-col cols="12" class="d-flex flex-row justify-space-between align-content-center my-4">
                            <span class="d-flex flex-row align-center">
                                <v-autocomplete dense outlined
                                    label="ordina per"
                                    v-model="sort_fields"
                                    :items="sorting_fields"
                                    item-value="value"
                                    item-text="label"
                                    return-object
                                    hide-details
                                    @change="changeOrder"
                                ></v-autocomplete>
                                <v-switch class="pl-4" v-if="viewFilterChoices" flat @change="changeSwitchFilter" true-value="org" false-value="owner" v-model="switchView">
                                    <template #prepend>
                                        <v-label class="body-1">proprietà</v-label>
                                    </template>
                                    <template #append>
                                        <v-label class="body-1">tutti</v-label>
                                    </template>
                                </v-switch>
                            </span>
                            <span v-if="!advanced_search"><v-btn color="primary" @click.stop="openAdvancedSearch"><v-icon class="mr-2">filter_list</v-icon>filtra</v-btn></span>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="!op_type">
                        <v-tabs
                            class="mb-2"
                            grow
                            background-color="primary"
                            dark
                            v-model="op_idx">
                                <v-tab
                                    v-for="(obj,idx) in Object.keys(r_status)"
                                    :key="idx">
                                    {{op_types[obj].prefix}}
                                </v-tab>
                        </v-tabs>
                    </v-row>
                </v-container>
            </div>
            <div v-if="!searching">
                <v-data-table
                    class="px-4"
                    :items="objects"
                    :page.sync="page"
                    :items-per-page="itemsPerPage"
                    dense
                    hide-default-header
                    hide-default-footer
                    @page-count="pageCount = $event">
                    <template v-slot:body="{ items }">
                    <tbody >
                        <div v-if="objects.length == 0" class="px-2 text-h6 text-center">
                            Nessun report trovato
                        </div>
                        <tr class="pa-0 ma-0" v-for="item in items" :key="item._id">
                            <td class="pa-0 ma-0" >
                            <ReportItem
                                class="full-width"
                                :key="item._id"
                                :report_id="item._id"
                                :show_instrument="true"
                                :show_client_short="true"
                                @report_removed="updateSearch">
                            </ReportItem>
                            </td>
                        </tr>
                    </tbody>
                    </template>
                </v-data-table>
                <div v-if="objects.length > 0" class="text-center pa-2">
                    <div class="text-right font-italic font-small">Totale: {{ this.objects.length }}</div>
                    <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7"></v-pagination>
                </div>
            </div>
        </BasicCard>
        
    </div>
</template>

<script>
import {ListManagement} from "../../utils/listMixin"
import {report_type} from "../../utils/common.js"
import {report_status_transition} from "../../utils/statusManagement"
import BasicCard from "../../components/utils/Basic_card"
import {filterOpType} from "../../utils/rolesManagement"
import ReportItem from './ReportItem'
import {i_families} from "../../utils/common.js"
import { subDays, startOfDay, endOfDay } from 'date-fns'
import { searchDesign, orderByFields } from "../../utils/dbUtility.js"
import { filterByOrg, filterByUser } from '../../utils/rolesManagement'
// import _ from 'lodash'


export default {
    components:{BasicCard, ReportItem },
    mixins: [ListManagement],
    props: {
        'lock_client': {
            type: Boolean,
            required: false,
            default: false
        },
        'client_id': {
            type: String,
            required: false,
            default: null
        },
        'op_type': {
            type: String,
            required: false,
            default: null
        },
        'filter_status': {
            type: Array,
            required: false,
            default: null
        },
        'filter_org': {
            type: Boolean,
            required: false,
            default: true
        }
    },
    
    data(){
        return {
            disabledForNow: true,    // flag to disable buttons (check methods)
            sorting_fields: [
                {label: 'data report', value: ['value.report_date', 'value.review_date', 'value.code'], order: ['desc', 'desc', 'asc']},
                {label: 'data riesame', value:['value.review_date', 'value.report_date', 'value.code'], order: ['desc', 'desc', 'asc']},
                {label: 'codice report', value:['value.code', 'value.review_date', 'value.report_date'], order: ['asc', 'desc', 'desc']},
            ],
            sort_fields: {},
            db: 'reports',
            filter: {
                client_id: this.client_id ? this.client_id : null,
                location_id: null,
                department_id: null,
                report_code: null,
                search_family: [],
                operator: null,
                op_type: this.op_type ? this.op_type : null,
                status: null,
                from: null,
                to: null
            },
            // report_types: report_type,
            status: [],
            families: i_families,
            searching: false,
            page: 1,
            itemsPerPage: 10,
            pageCount: 0,
            clients: [],
            locations: [],
            op_types: report_type,
            op_idx: 0,
            r_status: [],
            filtered_org: null,
            filtered_user: null,
            list_type: 'report'
        }
    },
    async beforeMount() {
        this.filterUsersSelection()
    },
    async mounted() {
        console.log("°°°°°°°°°°°°°°°",this.$router.history.current.fullPath)
        let filter = this.restore_history_params()
        this.setSwitchView()
        
        this.allowed = filterOpType(this.$store.state.user.report_type)
        this.r_status = Object.keys(report_status_transition)
            .filter(key => {
                return report_type[key].enabled && Object.keys(this.allowed).includes(key)}
            )
            .reduce((obj, key) => {
                obj[key] = report_status_transition[key];
                return obj;
            }, {})
            
        
        if (!filter) {
            this.resetSearch()
        } else if (this.client_id && filter.client_id != this.client_id) {
            this.resetSearch()
        } else {
            this.advanced_search = true
            this.filter = Object.assign({}, this.filter, filter)
            await this.getClients()
        }
        if (this.filter.client_id) {
            await this.getLocations()
            await this.getDepartments()
        } else {
            await this.getClients()
        }
        this.filterUsersSelection()
        this.changeSwitchFilter()
    },
    beforeDestroy() {
        this.object = []
    },
    methods: {
        
        resetSearch(){
            let status = this.filter_status
            if (!status || status.length == 0) {
                status = []
            }
            let op_type = this.op_type
            if (!op_type) {
                this.op_idx = 0
                op_type = Object.keys(this.r_status)[this.op_idx]
            }
            this.filter  = {
                client_id: this.client_id ? this.client_id : null,
                location_id: null,
                department_id: null,
                report_code: null,
                operator: null,
                search_family: [],
                op_type: op_type,
                status: status,
                from: null,
                to: null
            }
            this.$store.commit('setSearchParam', {path: this.$router.history.current.fullPath, filter: null, page:1, sort_fields: this.sorting_fields[0]})
        },
         async getClients(){
                let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', 'client', false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                this.clients = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.clients = []
            }
        },
        async getDepartments() {
            if (this.filter.location_id) {
                let location = await this.$store.state.$pouch.get("registry", this.filter.location_id)
                this.departments = Object.values(location.departments)
            } else {
                this.filter.department_id = null
                this.departments = []
            }
        },
        async getLocations() {
            let res = await searchDesign(this.$store.state.$pouch, 'registry', 'registry/searchByData', 'key', ['client', this.filter.client_id], false)
            if (res != null) {
                res = res.map(item => { return { _id: item.id, value: item.value } })
                this.locations = orderByFields(res, {value: ['value.name', 'value.updated'], order: ['asc', 'asc']})
            } else {
                this.locations = []
            }
        },
        async updateClient() {
          if (this.filter.client_id) {
              await this.getLocations()
            } else {
                this.filter.location_id = null
                this.filter.department_id = null
                this.locations = []
                this.departments = []
            }
        },
        async updateSearch() {
            this.searching = true
            if (this.filtered_user) {
                this.filter.operator = this.filtered_user
            } else if (!this.advanced_search) {
                this.filter.operator = null
            }
            if (this.filtered_org) {
                this.filter.org = this.filtered_org
            } else {
                this.filter.org = null
            }
            var selectors = ['report']
            if (this.filter.client_id) {
                selectors.push(['client', this.filter.client_id])
            }
            if (this.filter.location_id) {
                selectors.push(['location', this.filter.location_id])
            }
            if (this.filter.report_code) {
                selectors.push(['report_code', this.filter.report_code])
            }
            if (this.filter.op_type) {
                selectors.push(['op_type', this.filter.op_type])
            }
            if (this.filter.operator) {
                selectors.push(['owner_id', this.filter.operator])
            }
            if (this.filter.org) {
                selectors.push(['org', this.$store.state.user.org_id])
            }
            let res = []
            if (this.filter.status && this.filter.status.length > 0) {
                for (let status of this.filter.status){
                    let sel = _.cloneDeep(selectors)
                    sel.push(['status', status])
                    console.log('status', sel)
                    let tmp_res = await this.searchFromDesignNew('reports/searchByData', 'all_keys', sel, false)
                    res = _.union(res, tmp_res)
                    console.log('res', res)
                }
                    
            } else {
                res = await this.searchFromDesignNew('reports/searchByData', 'all_keys', selectors, false)
            }
            if (this.filter.from || this.filter.to) {
                let from = 0
                let d_to = new Date()
                d_to.setFullYear(d_to.getFullYear() + 50)
                let to = d_to.getTime()
                if (this.filter.from) {
                    from = this.filter.from
                }
                if (this.filter.to) {
                    to = this.filter.to
                }
                let sd_from = startOfDay(from).getTime()
                let ed_to = endOfDay(to).getTime()
                let res_date = await this.searchFromDesignNew('reports/searchByData', 'range', [['report_date', sd_from], ['report_date', ed_to]], false)
                res = _.intersectionWith(res, res_date, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
            }
            if (this.filter.search_family.length > 0) {
                res = res.filter((report) => {
                    return this.filter.search_family.includes(report.value.family)
                })
            }
            this.objects = this.orderBy(res, this.sort_fields)

            /*
            if (this.filter.search_family.length > 0) {
                let f_keys = [...Array(this.filter.search_family.length)].map((_, i) => ['family', this.filter.search_family[i]])
                let f_instrs = await searchDesign(this.$store.state.$pouch, 'registry', 'instruments/searchByData', 'keys', f_keys, false)
                let i_ids = _.map(f_instrs, 'id');
                let i_ops = await this.searchFromDesignNew('reports/searchByData', 'keys', i_ids, false)
                let items = _.intersectionWith(res, i_ops, function(arrVal, othVal){
                    return arrVal._id == othVal._id
                })
                this.objects = this.orderBy(items, this.sort_fields)
            } else {
                this.objects = this.orderBy(res, this.sort_fields)
            }*/
            
            this.searching = false
        },
        periodChange(f_days, t_days) {
            let now = (new Date()).getTime()
            this.filter.from = subDays(now, f_days).getTime()
            this.filter.to = subDays(now, t_days).getTime()
        },
        removeReport(r_id) {
            let idx = _.findIndex(this.objects, function(r) { return r_id == r._id });
            this.objects.splice(idx, 1)
        }
    },
    watch: {
        'op_idx': {
            handler() {
                let op_type = Object.keys(this.r_status)[this.op_idx]
                console.log('op_type', op_type)
                this.filter.op_type = op_type
                this.status = Object.keys(report_status_transition[this.filter.op_type]).map(key => { 
                    return Object.assign({id: key}, report_status_transition[this.filter.op_type][key])
                })
                this.updateSearch()
            }
        }
    },
    computed: {
        viewFilterChoices() {
            if(this.$store.state.user.roles.includes("reviewer")){
                return false
            }
            return filterByUser('operation', 'view_owner', this.$store.state.user.roles) && filterByOrg('operation', 'view_org', this.$store.state.user.roles)
        }
    }
}
</script>